import {
  USER_GET_REQUEST,
  USER_GET_REQUEST_FAILED,
  USER_GET_REQUEST_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED,
  COMPANY_PLAN_GET_REQUEST,
  COMPANY_PLAN_GET_REQUEST_FAILED,
  COMPANY_PLAN_GET_REQUEST_SUCCESS,
  PLANS_GET_REQUEST,
  PLANS_GET_REQUEST_FAILED,
  PLANS_GET_REQUEST_SUCCESS,
  SUBSCRIPTION_UPDATE_REQUEST,
  SUBSCRIPTION_UPDATE_REQUEST_FAILED,
  SUBSCRIPTION_UPDATE_REQUEST_SUCCESS,
  PAYMENT_GET_CARDS,
  PAYMENT_GET_CARDS_FAILED,
  PAYMENT_GET_CARDS_SUCCESS,
  PAYMENT_ADD_CARD,
  PAYMENT_ADD_CARD_FAILED,
  PAYMENT_ADD_CARD_SUCCESS,
  PAYMENT_SELECT_CARD,
  PAYMENT_SELECT_CARD_FAILED,
  PAYMENT_SELECT_CARD_SUCCESS,
  PAYMENT_REMOVE_CARD,
  PAYMENT_REMOVE_CARD_FAILED,
  PAYMENT_REMOVE_CARD_SUCCESS,
  PAYMENT_GET_HISTORY,
  PAYMENT_GET_HISTORY_FAILED,
  PAYMENT_GET_HISTORY_SUCCESS,
  PAYMENT_GET_STATISTICS,
  PAYMENT_GET_STATISTICS_FAILED,
  PAYMENT_GET_STATISTICS_SUCCESS,
  PROFILES_GET_REQUEST,
  PROFILES_GET_REQUEST_FAILED,
  PROFILES_GET_REQUEST_SUCCESS,
  PROFILE_REMOVE_REQUEST,
  PROFILE_REMOVE_REQUEST_FAILED,
  PROFILE_REMOVE_REQUEST_SUCCESS,
  PROFILE_EDIT_REQUEST,
  PROFILE_EDIT_REQUEST_FAILED,
  PROFILE_EDIT_REQUEST_SUCCESS
} from "../constants";

export const getUserInfo = () => {
  return { type: USER_GET_REQUEST };
};

export const getUserInfoSuccess = payload => {
  return { type: USER_GET_REQUEST_SUCCESS, payload };
};

export const getUserInfoFailed = payload => {
  return { type: USER_GET_REQUEST_FAILED, payload };
};

export const resetPassword = () => {
  return { type: RESET_PASSWORD };
};

export const resetPasswordFailed = payload => {
  return { type: RESET_PASSWORD_FAILED, payload };
};

export const getCompanyPlan = () => {
  return { type: COMPANY_PLAN_GET_REQUEST };
};

export const getCompanyPlanSuccess = payload => {
  return { type: COMPANY_PLAN_GET_REQUEST_SUCCESS, payload };
};

export const getCompanyPlanFailed = payload => {
  return { type: COMPANY_PLAN_GET_REQUEST_FAILED, payload };
};

export const getPlans = () => {
  return { type: PLANS_GET_REQUEST };
};

export const getPlansSuccess = payload => {
  return { type: PLANS_GET_REQUEST_SUCCESS, payload };
};

export const getPlansFailed = payload => {
  return { type: PLANS_GET_REQUEST_FAILED, payload };
};

export const updateSubscription = payload => {
  return { type: SUBSCRIPTION_UPDATE_REQUEST, payload };
};

export const updateSubscriptionFailed = payload => {
  return { type: SUBSCRIPTION_UPDATE_REQUEST_FAILED, payload };
};

export const updateSubscriptionSuccess = payload => {
  return { type: SUBSCRIPTION_UPDATE_REQUEST_SUCCESS, payload };
};

export const paymentGetCards = payload => {
  return { type: PAYMENT_GET_CARDS, payload };
};

export const paymentGetCardsFailed = payload => {
  return { type: PAYMENT_GET_CARDS_FAILED, payload };
};

export const paymentGetCardsSuccess = payload => {
  return { type: PAYMENT_GET_CARDS_SUCCESS, payload };
};

export const paymentAddCard = payload => {
  return { type: PAYMENT_ADD_CARD, payload };
};

export const paymentAddCardFailed = payload => {
  return { type: PAYMENT_ADD_CARD_FAILED, payload };
};

export const paymentAddCardSuccess = payload => {
  return { type: PAYMENT_ADD_CARD_SUCCESS, payload };
};

export const paymentSelectCard = payload => {
  return { type: PAYMENT_SELECT_CARD, payload };
};

export const paymentSelectCardFailed = payload => {
  return { type: PAYMENT_SELECT_CARD_FAILED, payload };
};

export const paymentSelectCardSuccess = payload => {
  return { type: PAYMENT_SELECT_CARD_SUCCESS, payload };
};

export const paymentRemoveCard = payload => {
  return { type: PAYMENT_REMOVE_CARD, payload };
};

export const paymentRemoveCardFailed = payload => {
  return { type: PAYMENT_REMOVE_CARD_FAILED, payload };
};

export const paymentRemoveCardSuccess = payload => {
  return { type: PAYMENT_REMOVE_CARD_SUCCESS, payload };
};

export const paymentGetHistory = payload => {
  return { type: PAYMENT_GET_HISTORY, payload };
};

export const paymentGetHistoryFailed = payload => {
  return { type: PAYMENT_GET_HISTORY_FAILED, payload };
};

export const paymentGetHistorySuccess = payload => {
  return { type: PAYMENT_GET_HISTORY_SUCCESS, payload };
};

export const paymentGetStatistics = payload => {
  return { type: PAYMENT_GET_STATISTICS, payload };
};

export const paymentGetStatisticsFailed = payload => {
  return { type: PAYMENT_GET_STATISTICS_FAILED, payload };
};

export const paymentGetStatisticsSuccess = payload => {
  return { type: PAYMENT_GET_STATISTICS_SUCCESS, payload };
};

export const profilesGet = payload => {
  return { type: PROFILES_GET_REQUEST, payload };
};

export const profilesGetFailed = payload => {
  return { type: PROFILES_GET_REQUEST_FAILED, payload };
};

export const profilesGetSuccess = payload => {
  return { type: PROFILES_GET_REQUEST_SUCCESS, payload };
};

export const profileRemove = payload => {
  return { type: PROFILE_REMOVE_REQUEST, payload };
};

export const profileRemoveFailed = payload => {
  return { type: PROFILE_REMOVE_REQUEST_FAILED, payload };
};

export const profileRemoveSuccess = payload => {
  return { type: PROFILE_REMOVE_REQUEST_SUCCESS, payload };
};

export const profileEdit = payload => {
  return { type: PROFILE_EDIT_REQUEST, payload };
};

export const profileEditFailed = payload => {
  return { type: PROFILE_EDIT_REQUEST_FAILED, payload };
};

export const profileEditSuccess = payload => {
  return { type: PROFILE_EDIT_REQUEST_SUCCESS, payload };
};
